// components/Clarity.tsx
"use client";
import { useEffect } from "react";

const CLARITY_ID = process.env.NEXT_PUBLIC_CLARITY_ID ?? "";

const ClarityInit = () => {
	useEffect(() => {
		if (typeof window === "undefined" || !CLARITY_ID) return;

		const loadClarity = () => {
			import("@microsoft/clarity")
				.then(({ default: Clarity }) => {
					Clarity.init(CLARITY_ID);
				})
				.catch(() => {});
		};

		if ("requestIdleCallback" in window) {
			const idleId = (
				window as unknown as {
					requestIdleCallback: (
						cb: () => void,
						opts?: { timeout: number },
					) => number;
				}
			).requestIdleCallback(loadClarity, { timeout: 3500 });

			return () => {
				if ("cancelIdleCallback" in window) {
					(
						window as unknown as {
							cancelIdleCallback: (id: number) => void;
						}
					).cancelIdleCallback(idleId);
				}
			};
		} else {
			const timer = setTimeout(loadClarity, 2500);
			return () => clearTimeout(timer);
		}
	}, []);

	return null;
};

export default ClarityInit;

